var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-bubble-menu"},[_c('menu-image-display-button',{attrs:{"editor":_vm.editor}}),_c('menu-edit-image-button',{attrs:{"editor":_vm.editor}}),_c('menu-remove-image-button',{attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }